import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const containerStyle = {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '2rem',
    lineHeight: '1.8',
    color: '#333'
  };

  const headingStyle = {
    color: '#2e7d32',
    marginTop: '2rem',
    marginBottom: '1rem'
  };

  const subHeadingStyle = {
    color: '#1b5e20',
    marginTop: '1.5rem',
    marginBottom: '0.5rem'
  };

  return (
    <div style={containerStyle}>
      <h1 style={{...headingStyle, textAlign: 'center', fontSize: '2.5rem'}}>
        Terms of Service
      </h1>
      
      <p style={{textAlign: 'center', color: '#666', marginBottom: '2rem'}}>
        Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
      </p>

      <div style={{background: '#f5f5f5', padding: '1.5rem', borderRadius: '8px', marginBottom: '2rem'}}>
        <p style={{margin: 0}}>
          <strong>Welcome to Gene!</strong> These Terms of Service ("Terms") govern your use of the Gene 
          genealogy research assistant service ("Service") operated by Thornbee LLC ("we," "us," or "our"). 
          By accessing or using Gene, you agree to be bound by these Terms.
        </p>
      </div>

      <h2 style={headingStyle}>1. Acceptance of Terms</h2>
      <p>
        By accessing and using Gene, you accept and agree to be bound by the terms and provision of this 
        agreement. If you do not agree to abide by the above, please do not use this service.
      </p>

      <h2 style={headingStyle}>2. Description of Service</h2>
      <p>
        Gene is an AI-powered genealogical research assistant powered by Generational Nexus (GNology™) 
        technology. The Service provides:
      </p>
      <ul>
        <li>Genealogical research guidance and recommendations</li>
        <li>Document analysis and interpretation</li>
        <li>Family history organization assistance</li>
        <li>Research strategy development</li>
        <li>Historical context and educational information</li>
      </ul>

      <h2 style={headingStyle}>3. Intellectual Property Rights</h2>
      <h3 style={subHeadingStyle}>3.1 Our Intellectual Property</h3>
      <p>
        Gene, Generational Nexus, GNology™, and all associated trademarks, service marks, graphics, and 
        logos are trademarks or registered trademarks of Thornbee LLC. Our trademarks and trade dress may 
        not be used in connection with any product or service without our prior written consent.
      </p>

      <h3 style={subHeadingStyle}>3.2 User Content</h3>
      <p>
        You retain all rights to the genealogical information, documents, and family history data you provide 
        to Gene ("User Content"). By submitting User Content, you grant Thornbee LLC a non-exclusive, 
        worldwide, royalty-free license to use, process, and analyze your content solely for the purpose 
        of providing and improving the Service.
      </p>

      <h2 style={headingStyle}>4. User Accounts</h2>
      <h3 style={subHeadingStyle}>4.1 Account Creation</h3>
      <p>
        To use certain features of Gene, you must create an account. You agree to:
      </p>
      <ul>
        <li>Provide accurate, current, and complete information</li>
        <li>Maintain and promptly update your account information</li>
        <li>Maintain the security of your password</li>
        <li>Accept responsibility for all activities under your account</li>
        <li>Notify us immediately of any unauthorized use</li>
      </ul>

      <h3 style={subHeadingStyle}>4.2 Age Requirements</h3>
      <p>
        You must be at least 18 years old to use Gene. By using the Service, you represent and warrant 
        that you meet this age requirement.
      </p>

      <h2 style={headingStyle}>5. Acceptable Use Policy</h2>
      <p>You agree not to use Gene to:</p>
      <ul>
        <li>Violate any laws or regulations</li>
        <li>Infringe upon the rights of others</li>
        <li>Upload false, misleading, or fraudulent information</li>
        <li>Attempt to gain unauthorized access to the Service</li>
        <li>Interfere with or disrupt the Service</li>
        <li>Use the Service for any illegal or unauthorized purpose</li>
        <li>Harass, abuse, or harm another person</li>
        <li>Impersonate any person or entity</li>
      </ul>

      <h2 style={headingStyle}>6. Privacy and Data Protection</h2>
      <p>
        Your use of Gene is also governed by our <Link to="/privacy" style={{color: '#2e7d32'}}>Privacy Policy</Link>, 
        which describes how we collect, use, and protect your personal information and genealogical data.
      </p>

      <h2 style={headingStyle}>7. Subscription and Payment Terms</h2>
      <h3 style={subHeadingStyle}>7.1 Free Trial</h3>
      <p>
        New users receive 250,000 tokens as a free trial to explore Gene's capabilities. No credit card 
        is required for the free trial.
      </p>

      <h3 style={subHeadingStyle}>7.2 Subscription Plans</h3>
      <p>
        After the free trial, continued use requires a paid subscription. Current plans include:
      </p>
      <ul>
        <li>Professional Plan: $100.00/month</li>
      </ul>

      <h3 style={subHeadingStyle}>7.3 Billing</h3>
      <p>
        Subscriptions are billed monthly or annually in advance. All fees are non-refundable except as 
        required by law or as explicitly stated in these Terms.
      </p>

      <h2 style={headingStyle}>8. Disclaimers</h2>
      <h3 style={subHeadingStyle}>8.1 Genealogical Information</h3>
      <p>
        Gene provides research assistance and guidance based on the information you provide and publicly 
        available historical records. We do not guarantee the accuracy, completeness, or reliability of 
        any genealogical information or research suggestions. Users should independently verify all 
        genealogical findings.
      </p>

      <h3 style={subHeadingStyle}>8.2 No Professional Advice</h3>
      <p>
        Gene is an educational and research tool. It does not provide legal, medical, or professional 
        genealogical certification services. For professional genealogical services, please consult a 
        certified genealogist.
      </p>

      <h2 style={headingStyle}>9. Limitation of Liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, THORNBEE LLC SHALL NOT BE LIABLE FOR ANY INDIRECT, 
        INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, 
        WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE 
        LOSSES RESULTING FROM YOUR USE OF GENE.
      </p>

      <h2 style={headingStyle}>10. Indemnification</h2>
      <p>
        You agree to indemnify and hold harmless Thornbee LLC, its officers, directors, employees, and 
        agents from any claims, disputes, demands, liabilities, damages, losses, and costs and expenses, 
        including reasonable legal fees, arising out of or in any way connected with your access to or 
        use of the Service.
      </p>

      <h2 style={headingStyle}>11. Modifications to Service</h2>
      <p>
        We reserve the right to modify or discontinue, temporarily or permanently, the Service (or any 
        part thereof) with or without notice. We shall not be liable to you or any third party for any 
        modification, suspension, or discontinuance of the Service.
      </p>

      <h2 style={headingStyle}>12. Termination</h2>
      <p>
        We may terminate or suspend your account and bar access to the Service immediately, without prior 
        notice or liability, under our sole discretion, for any reason whatsoever, including without 
        limitation if you breach the Terms.
      </p>

      <h2 style={headingStyle}>13. Governing Law</h2>
      <p>
        These Terms shall be governed and construed in accordance with the laws of the United States and 
        the State of North Carolina, without regard to its conflict of law provisions. Any disputes 
        arising from these Terms shall be resolved in the courts of North Carolina.
      </p>

      <h2 style={headingStyle}>14. Changes to Terms</h2>
      <p>
        We reserve the right to modify these Terms at any time. If we make material changes, we will 
        notify you by email or by posting a notice on the Service. Your continued use of Gene after 
        any such changes constitutes your acceptance of the new Terms.
      </p>

      <h2 style={headingStyle}>15. Contact Information</h2>
      <p>
        If you have any questions about these Terms, please contact us at:
      </p>
      <div style={{background: '#f5f5f5', padding: '1.5rem', borderRadius: '8px', marginTop: '1rem'}}>
        <p style={{margin: '0 0 0.5rem 0'}}><strong>Thornbee LLC</strong></p>
        <p style={{margin: '0 0 0.5rem 0'}}>Email: support@mygnology.com</p>
        <p style={{margin: '0'}}>Website: https://mygnology.com</p>
      </div>

      <div style={{marginTop: '3rem', padding: '2rem', background: '#e8f5e9', borderRadius: '8px', textAlign: 'center'}}>
        <p style={{margin: '0 0 1rem 0', fontSize: '1.1rem'}}>
          By using Gene, you acknowledge that you have read, understood, and agree to be bound by these Terms of Service.
        </p>
        <Link to="/research" style={{
          display: 'inline-block',
          padding: '0.75rem 2rem',
          background: '#2e7d32',
          color: 'white',
          borderRadius: '50px',
          textDecoration: 'none',
          fontWeight: '600'
        }}>
          Return to Gene →
        </Link>
      </div>
    </div>
  );
};

export default TermsOfService;
